export interface Constants {
  NOW: number
  DEBUG: boolean
  TIMER: Timer[]
  PROFILE: string
  PROJECT_DOMAIN: string
  PROJECT_ACTION_NAME: string
  PROJECT_STOP_ACTION: number
  PROJECT_START_ACTION: number
  IS_PROJECT_STOP_ACTION: boolean
  IS_PROJECT_START_ACTION: boolean
}

type Timer = {
  id: number
  title: string
  endDatetime: string
  startDatetime: string
  createDatetime: string
}

export interface Font {
  primary: string
  secondary?: string
  tertiary?: string
  other?: string
}

export type messageVariants = 'success' | 'warning' | 'error' | 'info' | 'reset'

export type Message = {
  [variant in messageVariants]?: string[]
}

export type AlertProps = {
  message?: Message
  rootModal?: string
  onClose?(): void
  onAction?(): void
  closeButton?: boolean
  title?: string
  fullScreen?: boolean
  actionButtonText?: string
}

export enum ApiAnswerStatus {
  SUCCESS = 1,
  FORBIDDEN = 403,
  BAD_REQUEST = 400,
  UNAUTHENTICATED = 401,
  NEED_FULL_REGISTER = 402,
}
